import { Observable } from "rxjs/internal/Observable";
import { catchError, map } from "rxjs/operators";
import { API_URL } from "../../enums/api.enums";
import HttpClient from "../http-client";
import Utils from "../../utils/base-utils";
import { IUserHistory } from "../../common/history.interface";


export default class HistoryApi {
    static apiURL = API_URL;

    static getHistory(body: any): Observable<any> {
        const queryParam = Utils.parseObjectToQueryParameter(body);
        const api = `${HistoryApi.apiURL.HOST}/${this.apiURL.GET_HISTORY}${queryParam}`;
        return HttpClient.get(api).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }

    static getAllUserHistory(): Observable<IUserHistory[]> {
        const api = `${HistoryApi.apiURL.HOST}/user-history/admin/all`;
        return HttpClient.get(api).pipe(
            map(
                (res) => (res as any) || [],
                catchError((error) => new Observable())
            )
        );
    }

}
